import { isErrorToastedGlobally } from '@api/index';
import { SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { toast } from 'sonner';

import { getIsInReceiveSession } from '@utils/helpers';

export const DEFAULT_ERROR_MESSAGE = 'Something went wrong. Please try again.';

type ApiError = {
  axiosErrorResponse?: unknown;
};

export const showApiErrorToast = (error: unknown) => {
  const apiError = error as ApiError | null | undefined;
  if (apiError && 'axiosErrorResponse' in apiError) return;
  if (isErrorToastedGlobally(apiError as FetchBaseQueryError | SerializedError | undefined)) return;

  toast.error(DEFAULT_ERROR_MESSAGE, {
    duration: 3000,
    className: getIsInReceiveSession() ? 'dark' : '',
  });
};
